// extracted by mini-css-extract-plugin
export default {"orange":"Orange_orange__2GTvO"};